import React from 'react';
import { Server } from '../../server/server';
import 'react-quill/dist/quill.snow.css';
import MessageModal from '../modals/MessageModal';
import AlertModal from '../modals/AlertModal';
import PageEnvelope from '../elements/PageEnvelope';
import PageHeader from '../elements/PageHeader';
import PostPanel from '../elements/PostPanel';
import ContentPanel from '../elements/ContentPanel';
import QuestionModal from '../modals/QuestionModal';
import ActivityButtons from '../elements/ActivityButtons';
import { Navigate } from 'react-router-dom';
import './SitePage.css'

interface ActivityPostPageState {
  post: any;
  message: string;
  alert: string;
  question: string;
  onQuestionYes: Function;
  loading: boolean;
  missing: boolean;
  date: string;
  navigate: string;
}

class ActivityPostPage extends React.Component<{}, ActivityPostPageState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      post: '',
      message: '',
      alert: '',
      question: '',
      onQuestionYes: null,
      loading: true,
      missing: false,
      date: '',
      navigate: ''
    };
  }

  componentDidMount() {
    this.getPost();
  }

  async getPost() {
    let id = window.location.pathname.substring(15);

    let response = await Server.activity.getPost(id);

    if (!response.success) {
      this.setState({missing: true});
      Server.activity.deletePostFromCache(id);
      return;
    }

    Server.activity.updatePostInCache(response.post);

    // cache profiles
    let profiles = [response.post.author];
    let replies = response.post.replies;

    for (let i = 0; i < replies.length; i++) {
      if(profiles.indexOf(replies[i].user) == -1)
        profiles.push(replies[i].user);
    }

    await Server.public.loadProfiles(profiles);

    this.setState({ post: response.post, loading: false });
  }

  onPostReply(content:string) {
    this.setState({message: 'Replying...'});

    setTimeout(async () => {
      let response = await Server.activity.createReply({
        id: this.state.post.id,
        content: content
      });
  
      this.setState({message: ''});

      if (response.success) 
        this.getPost();
      else
        this.setState({alert: response.message})
    }, 500);
  }

  onDeleteReply(date:string) {
    this.setState({
      question: 'Do you want to delete this reply?', 
      onQuestionYes: ()=>this.onDeleteReplyYes(),
      date
    });
  }

  onDeleteReplyYes() {
    this.setState({question: '', message: 'Deleting reply...'});
    setTimeout(async () => {
      let response = await Server.activity.deleteReply({
        id: this.state.post.id, 
        date: this.state.date
      })

      this.setState({message: ''});

      if(response.success) 
        this.getPost();
      else
        this.setState({alert: response.message});
    }, 500);
  }

  onDeletePost() {
    this.setState({
      question: 'Do you want to delete this post and all its replies?', 
      onQuestionYes: ()=>this.onDeletePostYes()
    });
  }

  onDeletePostYes() {
    this.setState({question: '', message: 'Deleting post...'});
    setTimeout(async () => {
      let response = await Server.activity.deletePost(this.state.post.id);
      if(response.success) {
        Server.activity.deletePostFromCache(this.state.post.id);
        this.setState({navigate: '/activity', message: ''});
      }
      else
        this.setState({alert: response.message, message: ''});
    }, 500);
  }

  renderLoading() {
    return (
      <div className="site-page-column">
        <PageHeader text={this.state.loading ? 'Loading...' : 'View Post'} navigate="/activity"/>

        {this.state.missing &&
          <div className="site-page-panel">
            This post has been deleted.
          </div>
        }
      </div>
    )
  }

  renderContent() {
    let replyDivs = [];
    let replies = this.state.post.replies;
    
    for (let i = replies.length - 1; i >= 0; i--) {
      let action = replies[i].user == Server.user.getId() ? 'delete' : '';
      replyDivs.push(
        <ContentPanel 
          key={i}
          author={replies[i].user}
          date={replies[i].date}
          content={replies[i].content}
          reply={true}
          action={action}
          onAction={()=>this.onDeleteReply(replies[i].date)}
        />
      )
    }

    let action = this.state.post.author == Server.user.getId() ? 'delete' : '';

    return (
      <div className="site-page-column">
        <PageHeader text="View Post" navigate="/activity" />

        <ContentPanel 
          author={this.state.post.author}
          date={this.state.post.date}
          content={this.state.post.content}
          action={action}
          onAction={()=>this.onDeletePost()}
        >
          <ActivityButtons 
            reposts={this.state.post.reposts} 
            reposted={this.state.post.reposted} 
            likes={this.state.post.likes} 
            liked={this.state.post.liked} 
            post={this.state.post} 
          />
        </ContentPanel>

        <PostPanel 
          placeholder="Enter reply..."
          onPost={(content:string)=>this.onPostReply(content)}
          words={1000}
        />

        {this.state.post.replies.length > 0 &&
          <div className="site-page-header"> {this.state.post.replies.length} Replies</div>
        }

        {replyDivs}
      </div>
    )
  }

  render() {
    if(this.state.navigate != '')
      return (<Navigate to={this.state.navigate} />);
      
    return (
      <div className="site-page">
        <PageEnvelope width="600px">
          {this.state.loading || this.state.missing ? this.renderLoading() : this.renderContent()}
        </PageEnvelope>

        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
        <QuestionModal message={this.state.question} onYes={()=>this.state.onQuestionYes()} onNo={()=>this.setState({question: ''})} />
      </div>
    );
  }
}

export default ActivityPostPage;